var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { EnvConfig } from '@/domains/base/types/env-config.interface';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
import { FolderListApiDto } from '../types/folder-list-api-dto.interface';
let FolderListApiImpl = class FolderListApiImpl {
    constructor(_envConfig, _psHttp, _folderListApiDto) {
        this._envConfig = _envConfig;
        this._psHttp = _psHttp;
        this._folderListApiDto = _folderListApiDto;
    }
    /**
     * 获取文件夹列表
     * @param spaceId
     * @returns Promise<FolderListApiResult>
     * */
    getFolderListApi(spaceId) {
        return this._psHttp({
            url: `${this._envConfig.workspaceApiUrlPrefix}/space/${spaceId}/folder-list`,
            method: 'GET',
            transformCode: true,
        }).then(({ data }) => {
            return this._folderListApiDto.transformListToTree(data.data);
        });
    }
    // addFolderApi(spaceId: string, folderName: string, params: AddFolderApiParams): Promise<void> {
    //     throw new Error('Method not implemented.');
    // }
    deleteFolderApi(spaceId, folderId) {
        return this._psHttp({
            url: `${this._envConfig.workspaceApiUrlPrefix}/space/${spaceId}/folder/${folderId}`,
            method: 'DELETE',
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
    // editFolderApi(spaceId: string, folderId: string, params: EditFolderApiParams): Promise<void> {
    //     throw new Error('Method not implemented.');
    // }
    sortFolderApi(spaceId, folderId, params) {
        return this._psHttp({
            url: `${this._envConfig.workspaceApiUrlPrefix}/space/${spaceId}/folder/${folderId}/drag-folder`,
            method: 'POST',
            data: {
                ...params,
            },
            transformCode: true,
        }).then(({ data }) => {
            return data.data || {};
        });
    }
};
FolderListApiImpl = __decorate([
    injectable(),
    __param(0, inject(EnvConfig)),
    __param(1, inject(PsHttp)),
    __param(2, inject(FolderListApiDto)),
    __metadata("design:paramtypes", [typeof (_a = typeof EnvConfig !== "undefined" && EnvConfig) === "function" ? _a : Object, typeof (_b = typeof PsHttp !== "undefined" && PsHttp) === "function" ? _b : Object, typeof (_c = typeof FolderListApiDto !== "undefined" && FolderListApiDto) === "function" ? _c : Object])
], FolderListApiImpl);
export { FolderListApiImpl };
